import { IerrorMessage } from './IPoliciesServiceModels';

interface ICorrespondenceListItem {
  id: number;
  type: {
    code: string;
    description: string;
  };
  accountNo: string;
  productId: number;
  productName: string;
  date: Date;
}
// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isCorrespondenceListItem(arg: any): arg is ICorrespondenceListItem {
  return (
    arg &&
    typeof arg.id !== 'undefined' &&
    typeof arg.type !== 'undefined' &&
    typeof arg.accountNo !== 'undefined' &&
    typeof arg.productId !== 'undefined' &&
    typeof arg.productName !== 'undefined' &&
    typeof arg.date !== 'undefined'
  );
}

interface ICorrespondenceDataItem {
  list: Array<ICorrespondenceListItem>;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}
// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isCorrespondenceDataItem(arg: any): arg is ICorrespondenceDataItem {
  return (
    arg &&
    typeof arg.list !== 'undefined' &&
    typeof arg.totalCount !== 'undefined' &&
    typeof arg.pageNumber !== 'undefined' &&
    typeof arg.pageSize !== 'undefined' &&
    typeof arg.totalPages !== 'undefined'
  );
}

interface ICorrespondenceData {
  data: ICorrespondenceDataItem;
  success: boolean;
  errors?: IerrorMessage;
}

// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isCorrespondenceData(arg: any): arg is ICorrespondenceData {
  return arg && typeof arg.data !== 'undefined' && typeof arg.success !== 'undefined';
}

export {
  ICorrespondenceData,
  ICorrespondenceDataItem,
  ICorrespondenceListItem,
  isCorrespondenceData,
  isCorrespondenceDataItem,
  isCorrespondenceListItem,
};
